module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_8019.075f96c5.png";